export const loginModal = {
  loginEmail: "Por favor ingresa su correo electrónico!",
  loginUserName: "Por favor ingresa su nombre de usuario!",
  loginPassword: "Por favor ingresa su contraseña!",
  loginForgotPassword: "¿Olvidaste tu contraseña?",
  loginPasswordRecoverTitle: "Recuperar contraseña",
  loginPasswordRecover: "Recuperación de clave exitosa",
  loginPasswordRecoverMsg: "Revise su correo para restablecer su contraseña",
  loginNoAccount: "¿No tienes cuenta?",
  loginRegister: "Regístrate",
  loginUserNotFound: "Usuario no encontrado",
  loginIncorrectPasswordEmail: "Usuario o Clave no válidos",
  loginSendBtn: "Iniciar sesión",
  loginSessionTitle: "Iniciar Sesión",
  loginEmailPlaceholder: "Correo",
  loginEmailLocalPartPlaceholder: "usuario",
  loginEmailDomainOther: "Otro",
  loginEmailCustomDomainPlaceholder: "dominio.com",
  loginPasswordPlaceholder: "Contraseña",
  loginRecoverEmail:
    "¿No recuerdas el Email con el que te registraste? Recupera tu cuenta contactando con nuestro equipo de soporte.",
  loginSupport: "soporte técnico.",
  loginRememberEmail: "Recordar mi correo",
  loginWithGoogle: "Continuar con Google",
  loginOrDivider: "o",
  googleLoginError: "No se pudo iniciar sesión con Google. Intenta de nuevo.",
  googleNewUserRegister: "Tu cuenta de Google es nueva. Regístrate primero para continuar.",
};
